import JQueryView, { on } from '../../../../../common/views/jqueryView';
import $ from 'jquery';

export default class TemplateView extends JQueryView {
  paragraphImages: Array<string | ArrayBuffer | null>;

  constructor(paragraphImages: Array<string>) {
    super('.simple_form');
    this.paragraphImages = paragraphImages;
    this.render();
  }

  @on({ event: 'change', selector: '#company_ir_paragraph_image1' })
  onChangeParagraphImage1(event: JQuery.ChangeEvent) {
    this.renderImage(event, 1);
  }

  @on({ event: 'change', selector: '#company_ir_paragraph_image2' })
  onChangeParagraphImage2(event: JQuery.ChangeEvent) {
    this.renderImage(event, 2);
  }

  @on({ event: 'change', selector: '#company_ir_paragraph_image3' })
  onChangeParagraphImage3(event: JQuery.ChangeEvent) {
    this.renderImage(event, 3);
  }

  @on({ event: 'change', selector: '#company_ir_paragraph_image4' })
  onChangeParagraphImage4(event: JQuery.ChangeEvent) {
    this.renderImage(event, 4);
  }

  @on({ event: 'change', selector: '#company_ir_paragraph_image5' })
  onChangeParagraphImage5(event: JQuery.ChangeEvent) {
    this.renderImage(event, 5);
  }

  @on({ event: 'change', selector: '#company_ir_paragraph_image6' })
  onChangeParagraphImage6(event: JQuery.ChangeEvent) {
    this.renderImage(event, 6);
  }

  @on({ event: 'change', selector: '#company_ir_paragraph_image7' })
  onChangeParagraphImage7(event: JQuery.ChangeEvent) {
    this.renderImage(event, 7);
  }

  @on({ event: 'change', selector: '#company_ir_paragraph_image8' })
  onChangeParagraphImage8(event: JQuery.ChangeEvent) {
    this.renderImage(event, 8);
  }

  renderImage(event: JQuery.ChangeEvent, imageNumber: number) {
    const file = $(event.target).prop('files')[0];
    const fr = new FileReader();
    fr.onload = () => {
      this.paragraphImages[imageNumber - 1] = fr.result;
      this.render();
    };
    fr.readAsDataURL(file);
  }

  @on({ event: 'click', selector: '.remove_fields' })
  onClickRemoveFields(event: JQuery.ClickEvent) {
    $(event.target).prev('input[type=hidden]').val('1');
    $(event.target).closest('fieldset').hide();
    event.preventDefault();
  }

  @on({ event: 'click', selector: '.add_fields' })
  onClickAddFields(event: JQuery.ClickEvent) {
    const time = new Date().getTime();
    const regexp = new RegExp($(event.target).data('id'), 'g');
    $(event.target).before(
      $(event.target).data('fields').replace(regexp, time),
    );
    event.preventDefault();
  }

  render() {
    for (let i = 1; i < this.paragraphImages.length + 1; i++) {
      if (this.paragraphImages[i - 1] !== '') {
        $('#preview_image' + i)
          .css('background-image', `url(${this.paragraphImages[i - 1]})`)
          .show();
      }
    }
  }
}
